import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedUbs: {},
    ubses: [],
  }),

  mutations: {
    setSelectedUbs(state, ubs) {
      Vue.set(state, "selectedUbs", ubs);
    },
    setUbses(state, ubses) {
      Vue.set(state, "ubses", ubses);
    },
    setDefaultUbsesModule(state, ubses) {
      Vue.set(state, "selectedUbs", ubses);
      Vue.set(state, "ubses", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createUbs: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/ubs-car-types/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadUbses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadPublishedUbses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/entity/published").then((response) => {
        return response.data;
      });
    },

    loadUbsHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/ubs-car-types/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedUbsHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    searchUbsByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/ubs-car-types/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteUbs: (context, ubs) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/ubs-car-types/entity/" + ubs.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          ubs.intents = intents;
          ubs.intentId = response.data.id;
          return ubs;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftUbs: (context, ubs) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/ubs-car-types/draft/" + ubs.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishUbs: (context, ubs) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/publish/" + ubs.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectUbs: (context, ubs) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/reject/" + ubs.intentId).then((response) => {
        if (ubs.intents[0].type === "DELETE_UBS_CAR_TYPE") {
          ubs.intents = null;
          ubs.intentId = 0;
        } else if (ubs.intents[0].type === "CREATE_UBS_CAR_TYPE") {
          ubs.intents[0].status = "DRAFT";
        } else if (ubs.intents[0].type === "UPDATE_UBS_CAR_TYPE") {
          ubs.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallUbs: (context, ubs) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/recall/" + ubs.intentId).then((response) => {
        helper.recallOrRejectEntity(ubs, "UBS_CAR_TYPE");
        return response.data;
      });
    },

    cancelUbs: (context, ubs) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/cancel/" + ubs.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalUbses: (context, ubs) => {
      return axios.get(context.getters.getMcServiceUrl + "/ubs-car-types/sendToApproval/" + ubs.intentId).then((response) => {
        if (ubs.intents[0].type === "CREATE_UBS_CAR_TYPE") {
          ubs.intents[0].status = "WAITING_APPROVAL";
        } else if (ubs.intents[0].type === "UPDATE_UBS_CAR_TYPE") {
          ubs.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
  },

  getters: {
    getSelectedUbs: (state) => {
      return state.selectedUbs;
    },
    getUbses: (state) => {
      return state.ubses;
    },
    getPublishedUbses: (state) => {
      return state.ubses.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
